import Dashboard from 'domain/layout/container';
import { route } from 'domain/witchcraft/tables/routes';
// import { route as CeoDashboardRoute } from 'domain/CEO/container';

const indexRoutes = [
  { path: '/', name: 'Home', component: Dashboard },
  { ...route },
  // { ...CeoDashboardRoute },
  { path: '/drivers', name: 'Home', component: Dashboard },
  { path: '/shipments', name: 'shipments', component: Dashboard },
];

export default indexRoutes;
